export const accountCan = (account, feature) => {
    if(account && account.features && Array.isArray(account.features) && account.features.includes(feature)){
        return true
    }
    return false
}